<template>
  <BaseButton primary small @click="open">
    <span class="truncate"> Edit </span>
  </BaseButton>
</template>

<script>
import { tagsClient } from '@/api/clients';

export default {
  props: {
    tag: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('Components/Tags/TagEditModal.vue'),
        props: {
          action: this.updateTag,
          tag: this.tag,
        },
        on: {
          'tag-updated': (tag) => {
            this.$emit('tag-updated', tag);
          },
        },
        hideEvent: 'hide',
      });
    },
    updateTag(formData) {
      return tagsClient.update(this.tag.id, formData);
    },
  },
};
</script>
